enum InquiryActionTypes {
	GET_INQUIRY = "GET_INQUIRY",
	GET_ALL_INQUIRIES = "GET_ALL_INQUIRIES",
	SET_INQUIRY_ID = "SET_INQUIRY_ID",
	SET_INQUIRY_ERROR = "SET_INQUIRY_ERROR",
	GET_DELETED_INQUIRIES = "GET_DELETED_INQUIRIES",
	UPDATE_INQUIRY = "UPDATE_INQUIRY",
	DELETE_INQUIRY = "DELETE_INQUIRY",
	REPLY_INQUIRY = "REPLY_INQUIRY",
}

export default InquiryActionTypes;
